import { tv } from 'tailwind-variants'

export const iconSize = tv({
  base: '',
  variants: {
    size: {
      xsmall: 'h-4 w-4',
      small: 'h-6 w-6',
      medium: 'h-10 w-10',
      large: 'h-16 w-16',
      xlarge: 'h-[104px] w-[104px]',
    },
  },
})
